export enum UserRoles {
  Owner = 'owner',
  Editor = 'editor',
  Viewer = 'viewer'
}

export enum DeleteRoleDraft {
  Remove = 'remove',
  Leave = 'leave'
}

//!: this Enum could disappear in a close future, that why we do not parse image with zod in the store
export enum ProcessImageTag {
  STAGING = 'staging-stratumn-com',
  PREPROD = 'preprod-stratumn-com',
  DEMO = 'demo-stratumn-com',
  RELEASE = 'release-stratumn-com',
  RELEASE_TEST = 'release-test-stratumn-com' // ? TEMP for test worfklows
}

export enum ProcessTag {
  PROD = 'prod',
  DEV = 'dev',
  TEST = 'test',
  DEMO = 'demo'
}

export const PROCESS_TAG_CONFIG: Record<
  ProcessTag,
  { label: string; className: string }
> = {
  [ProcessTag.PROD]: {
    label: 'Prod',
    className: 'bg-red-100 text-red-700 border-red-200'
  },
  [ProcessTag.DEV]: {
    label: 'Dev',
    className: 'bg-blue-100 text-blue-700 border-blue-200'
  },
  [ProcessTag.TEST]: {
    label: 'Test',
    className: 'bg-emerald-100 text-emerald-700 border-emerald-200'
  },
  [ProcessTag.DEMO]: {
    label: 'Demo',
    className: 'bg-purple-100 text-purple-700 border-purple-200'
  }
};
